import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createLevelApi, getLevelApi, updateLevelApi } from "./levelApi";

export const getLevelRequest = createAsyncThunk(
  "getLevelRequest/level",
  async () => {
    try {
      const response = await getLevelApi();
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const createLevelRequest = createAsyncThunk(
  "createLevelRequest/level",
  async (payload: any) => {
    try {
      const response = await createLevelApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const updateLevelRequest = createAsyncThunk(
  "updateLevelRequest/level",
  async (payload: any) => {
    try {
      const response = await updateLevelApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  levelList: any[];
  levelPost: any;
  levelUpdate: any;
  message: string;
  isSuccess: boolean;
  pageIsLoading: boolean;
}

const initialState: IInitialState = {
  levelList: [],
  levelPost: {},
  levelUpdate: {},
  message: "",
  isSuccess: false,
  pageIsLoading: false,
};

const levelSlice = createSlice({
  name: "level",
  initialState: initialState,
  reducers: {
    resetMessageLevel: (state) => {
      state.message = "";
    },
    resetSuccessLevel: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers(builder) {
    // get department reducer
    builder.addCase(getLevelRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getLevelRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.levelList = action.payload.data;
        state.pageIsLoading = false;
      } else {
        // state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getLevelRequest.rejected, (state) => {
      state.pageIsLoading = false;
    });

    // create department reducer
    builder.addCase(createLevelRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(createLevelRequest.fulfilled, (state, action) => {
      console.log(action);

      if (action.payload.status === 1000) {
        state.levelPost = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(createLevelRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });

    // update department reducer
    builder.addCase(updateLevelRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateLevelRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.levelUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateLevelRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageLevel, resetSuccessLevel } = levelSlice.actions;
export default levelSlice.reducer;
